// @flow

import { type TokenizedCard } from './types';

export function isValidTokenizedCard(tokenizedCard: TokenizedCard): boolean {
  return tokenizedCard && hasValidToken(tokenizedCard);
}

function hasValidToken(tokenizedCard: TokenizedCard): boolean {
  return !!tokenizedCard.last_digits && tokenizedCard.last_digits.trim() !== '';
}
